const SummaryData = [
  {
    id: 1,
    name: "Nelsa Web Development",
    manager: "Om Prakash Sao",
    date: "May 25, 2023",
    status: "Completed",
    progress: "100%"
  },
  {
    id: 2,
    name: "Datascale AI App",
    manager: "Neilsan Mando",
    date: "Jun 20, 2023",
    status: "Delayed",
    progress: "35%"
  },
  {
    id: 3,
    name: "Media Channel Branding",
    manager: "Tiruvelly Priya",
    date: "July 13, 2023",
    status: "At risk",
    progress: "68%"
  },
  {
    id: 4,
    name: "Corlax iOS App development",
    manager: "Matt Hannery",
    date: "Dec 20, 2023",
    status: "Completed",
    progress: "100%"
  },

  {
    id: 5,
    name: "Website Builder Development",
    manager: "Sukumar Rao",
    date: "Mar 15, 2024",
    status: "On going",
    progress: "50%"
  }
]


export default SummaryData;